import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Accordion, AccordionHeading } from '@yuno/sdk-web-core/dist/ui'

export const OrderContainer = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  padding: 80px;
`

export const OrderHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: flex-start;
  flex: 1 0 0;
`

export const MerchantLogo = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
`

export const Heading = styled.h1`
  ${({ theme }) => css({ ...theme.typographys.xl.bold })}
`

export const Instructions = styled.p`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
  color: ${({ theme }) => theme.colors.grey[4]};
`

export const OrderDetailTitleContainer = styled.div`
  display: flex;
  width: 100%;
`

export const OrderDetailTitleLeftContent = styled.div`
  flex-grow: 1;
  justify-content: left;
  display: flex;
  align-items: center;

  > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #6C6F75;
  }
`

export const OrderAccordion = styled(Accordion)`
  width: 100%;
  margin-top: -4px;
  border: none;
  box-shadow: none;

  > * {
    border: none;
    box-shadow: none;
  }

  .Yuno-accordion__heading {
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }

  .Yuno-accordion__heading-title {
    padding: 8px 0;
    border: none !important;
    background: transparent !important;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #6C6F75;
  }

  .close .Yuno-accordion__heading-title::after {
    right: 0;
  }

  .open .Yuno-accordion__heading-title::after {
    right: 2px;
  }
`

export const OrderDetailContentContainer = styled.div`
  display: flex;
  margin-top: 24px;
`

export const OrderDetailContentLeftContent = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-grow: 1;
  gap: 16px;
`

export const OrderDetailContentName = styled.div`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
  flex-grow: 1;
`

export const OrderTotalWrapper = styled.div`
  padding: 16px 0 2px 0;
`

export const OrderTotalContainer = styled.div`
  margin-top: 24px;
`

const OrderTotalItem = styled.div`
  padding: 16px 0;
  display: flex;
  justify-content: space-between;

  span {
    flex-grow: 0;
  }
`

export const OrderTotalSubtotal = styled(OrderTotalItem)`
  span {
    ${({ theme }) => css({ ...theme.typographys.small.regular })}
  }
`

export const OrderTotalDue = styled(OrderTotalSubtotal)<{
  hasProducts: boolean
}>`
  span:last-child {
    ${({ theme }) => css({ ...theme.typographys.m.bold })}
  }

  ${({ hasProducts }) =>
    !hasProducts &&
    `
    flex-direction: column;
    align-items: flex-start;

    span {
      text-align: left;
    }

    span:last-child {
      font-size: 32px;
      line-height: 40px;
      margin-top: 8px;
    }
  `}
`

export const OrderDetailPurchaseItem = styled.div`
  margin-top: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};

  &:last-child {
    border-bottom: none;
  }
`

export const OrderDetailPurchaseTitle = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;

  span:first-of-type {
    flex-grow: 1;
  }
`

export const OrderDetailPurchaseDetails = styled.div`
  display: flex;
  align-items: start;
  padding: 8px;
`

export const OrderDetailPurchaseDetailsArrival = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;

  span:nth-child(2) {
    margin-top: 10px;
  }
`

export const OrderDetailPurchaseTitleSeparator = styled.div`
  height: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.grey[4]};
  padding-left: 10px;
  margin-right: 10px;
`

export const OrderDetailPurchaseTitleSeparatorH = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};
  margin: 8px 12px 0 12px;
  flex-grow: 1;
`

export const OrderDetailPurchaseSpanRegular = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const OrderDetailPurchaseSpanBold = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.bold)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const AccordionHeadingPurchase = styled(AccordionHeading)`
  button {
    border: none;
    background-color: transparent;
    padding: 8px 0;
    ${({ theme }) => css(theme.typographys.tiny.bold)};
    color: ${({ theme }) => theme.colors.grey[5]};

    &::after {
      right: 0;
    }

    &[aria-expanded='true'] {
      &::after {
        right: 2px;
      }
    }
  }
`

export const OrderTotalPurchase = styled.div<{ hasProducts: boolean }>`
  ${({ hasProducts }) =>
    hasProducts &&
    `
    display: flex;
    justify-content: end;
  `}
`

export const OrderTotalPurchaseContainer = styled.div<{ hasProducts: boolean }>`
  ${({ hasProducts }) =>
    hasProducts &&
    `
    width: 366px;
    padding-right: 16px;
  `}
`

export const LeftPanelFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
  margin-bottom: 10px;
`
